import { type RefObject, useLayoutEffect, useRef } from "react";

export function useRouteScrollRestoration(
	elementRef: RefObject<HTMLElement | null>,
	pathname: string,
) {
	const previousPathnameRef = useRef(pathname);
	const scrollPositionsRef = useRef(new Map<string, number>());

	useLayoutEffect(() => {
		const element = elementRef.current;
		if (!element) {
			return;
		}

		const previousPathname = previousPathnameRef.current;
		if (previousPathname !== pathname) {
			scrollPositionsRef.current.set(previousPathname, element.scrollTop);
			previousPathnameRef.current = pathname;
		}

		element.scrollTop = scrollPositionsRef.current.get(pathname) ?? 0;
	}, [elementRef, pathname]);
}
